import { render } from "./OrderPage.vue?vue&type=template&id=e1444740&scoped=true&ts=true"
import script from "./OrderPage.ts?vue&type=script&lang=ts"
export * from "./OrderPage.ts?vue&type=script&lang=ts"

import "./OrderPage.vue?vue&type=style&index=0&id=e1444740&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1444740"]])

export default __exports__